import ModalInlineModCheck from './modal-inline-mod-check';
export default ModalInlineModCheck